import { observer } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import { withCheckoutStore } from '../../../context';
import MenuCategories from './containers/MenuCategories/MenuCategories';
import MenuCategoriesSearch from './containers/MenuCategoriesSearch/MenuCategoriesSearch';
import MenuCategory from './containers/MenuCategory/MenuCategory';
import MenuFavorites from './containers/MenuFavorites/MenuFavorites';
import { PAYMENT_TYPES } from 'src/constants/main';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import { menuStore } from 'src/mobx/menuStore';
import { IBranch } from 'src/types/branches';
import { CheckoutStore } from '~/mobx/checkoutStore';
import { CallCenterStore } from '~/mobx/ordersStore/callCenterStore';

interface IProps {
  branch: IBranch | undefined;
  time: Date | undefined;
  checkoutStore?: CheckoutStore;
}

// @ts-ignore
@withCheckoutStore
@observer
export default class Menu extends React.Component<IProps> {
  get checkoutStore() {
    return this.props.checkoutStore!;
  }

  componentDidMount = () => {
    menuStore.fetchMenu({
      branch: this.props.branch,
      time: moment(this.props.time).unix(),
      customerId: this.checkoutStore.dependencies.customer?.id,
      sort_products: true,
    });
  };

  get view() {
    if (menuStore.favorites) {
      return <MenuFavorites />;
    }
    if (menuStore.categoryId) return <MenuCategory />;

    return <MenuCategories />;
  }

  componentWillUnmount = () => {
    menuStore.clear();
  };

  public render() {
    return (
      <div className="d-flex flex-1 flex-column">
        <div className="d-flex mb-4">
          <MenuCategoriesSearch branchId={this.props.branch?.id} />
        </div>

        {!this.checkoutStore.isDraft ? (
          <>
            {this.checkoutStore.dependencies.order?.use_wallet ? (
              <div className="d-flex align-self-start  mb-4 radius-14 bg-redlight py-2 px-3 ">
                <span className=" text-size-14 family-medium color-red">{localeStore.t('order_paid_wallet')}</span>
              </div>
            ) : null}
            {appStore.settings?.is_foodics ? (
              <div className="d-flex align-self-start  mb-4 radius-14 bg-redlight py-2 px-3 ">
                <span className=" text-size-14 family-medium color-red">
                  {localeStore.t(
                    this.checkoutStore.parentStore instanceof CallCenterStore ? 'changes_foodics_notification' : 'changes_pos_notification'
                  )}
                </span>
              </div>
            ) : null}
            {this.checkoutStore.dependencies.order?.payment_type === PAYMENT_TYPES.ONLINE_PAYMENT &&
            this.checkoutStore.calculator.total > this.checkoutStore.dependencies.order.total ? (
              <div className="d-flex align-self-start  mb-4 radius-14 bg-redlight py-2 px-3 ">
                <span className=" text-size-14 family-medium color-red">{localeStore.t('order_paid_online_total_limit')}</span>
              </div>
            ) : null}
          </>
        ) : null}

        {this.view}
      </div>
    );
  }
}
